const EXPERIMENTAL_FUNNELS = {
	MALE_ACTIVITY_FUNNEL: {
		id: 'activity-male-funnel-instance',
		slug: 'male-activity',
		sex: 'male',
		theme: 'dark',
		fromS3: true
	},

	FEMALE_ACTIVITY_FUNNEL: {
		id: 'activity-female-funnel-instance',
		slug: 'female-activity',
		sex: 'female',
		theme: 'light',
		fromS3: true
	},

	FEMALE_EMAIL_BEFORE_PREDICT: {
		id: 'female-funnel-email-before-predict-instance',
		slug: 'female',
		fromS3: true
	},

	FEMALE_OPTIMIZED: {
		id: 'optimized-female-funnel-instance',
		slug: 'female',
		fromS3: true
	}
}

const FUNNELS = {
	// TODO: Only for account page edit data from account page
	LEGACY: {
		id: 'legacy-funnel-instance',
		slug: 'main',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl'],
		fromS3: true
	},

	MAIN: {
		id: 'main-funnel-instance',
		slug: 'main',
		fromS3: true
	},

	MAIN_NON_US: {
		id: 'main-funnel-instance-non-us',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl'],
		slug: 'main',
		fromS3: true
	},

	NOFASTING: {
		id: 'nofasting-funnel-instance',
		slug: 'main',
		locale: ['en'],
		fromS3: true
	},

	NOFASTING_MALE: {
		id: 'nofasting-male-funnel-instance',
		slug: 'male',
		theme: 'dark',
		locale: ['en'],
		fromS3: true
	},

	NOFASTING_FEMALE: {
		id: 'nofasting-female-funnel-instance',
		slug: 'female',
		locale: ['en'],
		fromS3: true
	},

	NOFASTING_ACTIVITY_MALE: {
		id: 'nofasting-activity-male-funnel-instance',
		slug: 'male-activity',
		theme: 'dark',
		sex: 'male',
		locale: ['en'],
		fromS3: true
	},

	MALE: {
		id: 'optimized-male-funnel-instance',
		slug: 'male',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl'],
		theme: 'dark',
		fromS3: true
	},

	MALE_EMAIL_BEFORE_PREDICT: {
		id: 'male-funnel-email-before-predict-instance',
		slug: 'male',
		theme: 'dark',
		fromS3: true
	},

	FEMALE: {
		id: 'female-funnel-instance',
		slug: 'female',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl'],
		fromS3: true
	},

	YOUTUBE: {
		id: 'youtube-funnel-instance',
		slug: 'youtube',
		fromS3: true
	},

	...EXPERIMENTAL_FUNNELS
}

const FUNNEL_PATH_PREFIXES = {
	male: '/men',
	female: '/women',
	activity: '/activity'
}

module.exports = {
	FUNNELS,
	FUNNEL_PATH_PREFIXES
}
